module.exports = __webpack_public_path__ + "img/DAVID_CANNON_06-rs.7542358c.jpg";